enum eTransition {
    in = 1,
    out = 2   
}

export default eTransition;